import { Controller } from "@hotwired/stimulus"

// Ticks a mm:ss timer down to zero, one second at a time. Decorative; holds at
// zero when it lands there and stays static for reduced-motion.
export default class extends Controller {
  static targets = ["display"]
  static values = { seconds: { type: Number, default: 1200 } }

  connect() {
    this.remaining = this.secondsValue
    this.render()
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  tick() {
    if (this.remaining <= 0) return clearInterval(this.timer)
    this.remaining -= 1
    this.render()
  }

  render() {
    const minutes = Math.floor(this.remaining / 60)
    const seconds = this.remaining % 60
    this.displayTarget.textContent = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
  }
}
